"use client"

export default function Footer() {
  return (
    <footer className="py-16 px-6 bg-dark text-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">GD</span>
              </div>
              <div>
                <h3 className="font-bold text-xl">GRON'S DODGEBALL</h3>
                <p className="text-orange-400 text-sm">Fast. Fun. Fierce.</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Groningen's premier dodgeball community bringing together players of all skill levels.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="#about" className="hover:text-orange-400 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#events" className="hover:text-orange-400 transition-colors">
                  Events
                </a>
              </li>
              <li>
                <a href="#memberships" className="hover:text-orange-400 transition-colors">
                  Memberships
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-orange-400 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="#" className="hover:text-orange-400 transition-colors">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-orange-400 transition-colors">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Gron's Dodgeball. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
